import { render, staticRenderFns } from "./AlertPreferences.vue?vue&type=template&id=e38e98be&scoped=true&"
import script from "./AlertPreferences.vue?vue&type=script&lang=js&"
export * from "./AlertPreferences.vue?vue&type=script&lang=js&"
import style0 from "./AlertPreferences.vue?vue&type=style&index=0&id=e38e98be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38e98be",
  null
  
)

export default component.exports